import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/')({
    beforeLoad: ({ params }): never => {
        throw redirect({
            to: '/console/$orgId/configuration/compliance/complaints/general',
            params,
            replace: true,
        });
    },
});
